import toastr from "toastr";
import { call, put, takeEvery } from "redux-saga/effects";

import {
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE, GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT, GET_AZURE_CLOUD_RESOURCES, 
    GET_AZURE_REFRESH, GET_AZURE_NOTIFICATION_CHANNELS, POST_AZURE_CREATE_RESOURCE_ALERTS, POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING, 
    POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING, POST_AZURE_RESOURCE_SERVICE_MAPPING, GET_ALL_ORG_AZURE_RESOURCE_TYPES,
    GET_USER_RESCAN_STATUS_AZURE
} from './actionTypes'
import {
    getAzureAllResourceAlertsPageFail, getAzureAllResourceAlertsPageSuccess,
    getAzureAllResourceAlertsPageCountSuccess, getAzureAllResourceAlertsPageCountFail,
    getAzureRefreshFail, getAzureRefreshSuccess,
    getAzureCloudResourcesSuccess, getAzureCloudResourcesFail,
    getAzureNotificationChannelsSuccess, getAzureNotificationChannelsFail,
    postAzureCreateResourceAlertsSuccess, postAzureCreateResourceAlertsFail,
    postAzureResourceOpsGenieTeamMappingSuccess, postAzureResourceOpsGenieTeamMappingFail,
    postAzureResourcePagerdutyServiceMappingFail, postAzureResourcePagerdutyServiceMappingSuccess,
    postAzureResourceServiceMappingSuccess, postAzureResourceServiceMappingFail,
    getAllOrgAzureResourceTypesSuccess, getAllOrgAzureResourceTypesFail,
    getAzureRefreshScanStatusFail, getAzureRefreshScanStatusSuccess
} from './actions'
import {
    getAzureAllResourceAlertsPageUrl, getAzureAllResourceAlertsCountPageUrl, 
    getAzureCloudResourcesUrl, getRefreshAzureResourcesUrl,
    getAzureNotificationChannelsUrl, postCreateAzureResourceAlertsUrl, postAzureResourceOpsgenieTeamMapping, 
    postAzureResourcePagerdutyServiceMappingCall, postAzureServiceMapping, getAllOrgAzureResourceTypesUrl,
    getRescanStatusAzureUrl

} from '../../helpers/fakebackend_helper'
import { showNotification } from "components/Common/notification";



function* onGetAzureRefresh() {
    try {
        const response = yield call(getRefreshAzureResourcesUrl);
        yield put(getAzureRefreshSuccess(response));
        if (response.scan_completed === false){
            showNotification('error', response.message);
        }
    } catch (error) {
        yield put(getAzureRefreshFail(error));
        if (error.response.data.message = "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* onGetAzureAllResourceAlertsPage({ payload: { page_filters } }) {
    try {
        const response = yield call(getAzureAllResourceAlertsPageUrl, page_filters);
        yield put(getAzureAllResourceAlertsPageSuccess(response));
    } catch (error) {
        yield put(getAzureAllResourceAlertsPageFail(error.message));
    }
}

function* onGetAzureAllResourceAlertsPageCount({ payload: { page_filters } }) {
    try {
        const response = yield call(getAzureAllResourceAlertsCountPageUrl, page_filters);
        yield put(getAzureAllResourceAlertsPageCountSuccess(response));
    } catch (error) {
        yield put(getAzureAllResourceAlertsPageCountFail(error.message));
    }
}

function* onGetAzureCloudResources() {
    try {
        const response = yield call(getAzureCloudResourcesUrl);
        yield put(getAzureCloudResourcesSuccess(response));
    } catch (error) {
        yield put(getAzureCloudResourcesFail(error.message));
    }
}

function* onGetAzureNotificationChannels() {
    try {
        const response = yield call(getAzureNotificationChannelsUrl);
        yield put(getAzureNotificationChannelsSuccess(response));
    } catch (error) {
        yield put(getAzureNotificationChannelsFail(error));
    }
}

function* onPostAzureCreateResourceAlerts({ payload: { data } }) {
    try {
        const response = yield call(postCreateAzureResourceAlertsUrl, data);
        yield put(postAzureCreateResourceAlertsSuccess(response));
    } catch (error) {
        yield put(postAzureCreateResourceAlertsFail(error));
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* onPostAzureResourceOpsgenieTeamMapping({ payload: { data } }) {
    try {
        const response = yield call(postAzureResourceOpsgenieTeamMapping, data);
        yield put(postAzureResourceOpsGenieTeamMappingSuccess(response));
        toastr.success("Opsgenie Team Mapping updated successfully!");
        yield new Promise(resolve => setTimeout(resolve, 3000));
        window.location.reload();
    } catch (error) {
        yield put(postAzureResourceOpsGenieTeamMappingFail(error.message));
    }
}

function* onPostAzureResourcePagerdutyServiceMapping({ payload: { data } }) {
    try {
        const response = yield call(postAzureResourcePagerdutyServiceMappingCall, data);
        yield put(postAzureResourcePagerdutyServiceMappingSuccess(response));
        toastr.success("Pagerduty Team Mapping updated successfully!");
        yield new Promise(resolve => setTimeout(resolve, 3000));
        window.location.reload();
    } catch (error) {
        yield put(postAzureResourcePagerdutyServiceMappingFail(error.message));
    }
}

function* onPostResourceServiceMapping({ payload: { data } }) {
    try {
        const response = yield call(postAzureServiceMapping, data);
        yield put(postAzureResourceServiceMappingSuccess(response));
        if (response) {
            showNotification("success", "Service Mapping updated successfully!");
        }
    } catch (error) {
        yield put(postAzureResourceServiceMappingFail(error.message));
        if (error) {
            showNotification("error", "Failed to update");
        }
    }
}

function* onGetAllOrgAzureResourceTypes() {
    try {
        const response = yield call(getAllOrgAzureResourceTypesUrl);
        yield put(getAllOrgAzureResourceTypesSuccess(response));
    } catch (error) {
        yield put(getAllOrgAzureResourceTypesFail(error.message));
    }
}

function* onGetUserRescanStatusAzure() {
    try {
        const response = yield call(getRescanStatusAzureUrl);
        yield put(getAzureRefreshScanStatusSuccess(response));
    } catch (error) {
        yield put(getAzureRefreshScanStatusFail(error.message));
    }

}
function* AzureSaga() {
    yield takeEvery(GET_AZURE_ALL_RESOURCE_ALERTS_PAGE, onGetAzureAllResourceAlertsPage);
    yield takeEvery(GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT, onGetAzureAllResourceAlertsPageCount);
    yield takeEvery(GET_AZURE_CLOUD_RESOURCES, onGetAzureCloudResources);
    yield takeEvery(GET_AZURE_REFRESH, onGetAzureRefresh);
    yield takeEvery(GET_AZURE_NOTIFICATION_CHANNELS, onGetAzureNotificationChannels);
    yield takeEvery(POST_AZURE_CREATE_RESOURCE_ALERTS, onPostAzureCreateResourceAlerts);
    yield takeEvery(POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostAzureResourceOpsgenieTeamMapping);
    yield takeEvery(POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING, onPostAzureResourcePagerdutyServiceMapping);
    yield takeEvery(POST_AZURE_RESOURCE_SERVICE_MAPPING, onPostResourceServiceMapping);
    yield takeEvery(GET_ALL_ORG_AZURE_RESOURCE_TYPES,onGetAllOrgAzureResourceTypes);
    yield takeEvery(GET_USER_RESCAN_STATUS_AZURE, onGetUserRescanStatusAzure);

}

export default AzureSaga;
